var _path, _path2, _circle, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkLockSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    viewBox: "0 0 64 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 30.7644V18.2026C45.8017 15.8128 45.3325 13.4461 44.4192 11.2378C43.5059 9.02942 42.1664 7.02265 40.4772 5.33221C38.788 3.64177 36.7822 2.30076 34.5745 1.38583C32.3668 0.470901 30.0004 0 27.6107 0C25.2209 0 22.8545 0.470901 20.6468 1.38583C18.4391 2.30076 16.4333 3.64177 14.7441 5.33221C13.0549 7.02265 11.7154 9.02942 10.8021 11.2378C9.88877 13.4461 9.41958 15.8128 9.42131 18.2026V30.7644C6.98994 30.8738 4.69435 31.9165 3.01208 33.6753C1.32981 35.4342 0.390368 37.7738 0.38916 40.2077V69.8925H54.8322V40.2077C54.8309 37.7738 53.8915 35.4342 52.2092 33.6753C50.527 31.9165 48.2314 30.8738 45.8 30.7644ZM27.6107 6.41751C30.7351 6.42115 33.7304 7.664 35.9397 9.87337C38.1489 12.0827 39.3916 15.0782 39.395 18.2026V30.7425H15.8264V18.2026C15.8298 15.0782 17.0724 12.0827 19.2817 9.87337C21.4909 7.664 24.4862 6.42115 27.6107 6.41751Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5042 45.3865C32.5045 44.5427 32.2866 43.7132 31.8717 42.9785C31.4568 42.2438 30.859 41.6288 30.1363 41.1933C29.4135 40.7578 28.5905 40.5166 27.7471 40.4931C26.9036 40.4695 26.0684 40.6644 25.3225 41.0589C24.5767 41.4534 23.9455 42.0341 23.4902 42.7445C23.035 43.4549 22.7711 44.271 22.7243 45.1135C22.6775 45.956 22.8493 46.7962 23.2231 47.5527C23.5969 48.3092 24.1599 48.9561 24.8576 49.4308V60.0678H30.3627V49.4308C31.0226 48.9826 31.5627 48.3798 31.936 47.6748C32.3093 46.9698 32.5044 46.1842 32.5042 45.3865Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.6106,
    cy: 20,
    r: 16,
    fill: "#5ACD81"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 85.8925,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 17L46.0001 24.3333L42.6667 21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicLinkLockSuccess);
export default __webpack_public_path__ + "static/media/magic-link-lock-success.3c1a473509e8c732b2b8838d33bb761f.svg";
export { ForwardRef as ReactComponent };